import React, { useState, useEffect } from 'react';

import './CustomFooter.scss';
import { useHistory, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import c from '../../config';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
} from 'reactstrap';
import facebookPng from '../../assets/images/common/facebook.png';
// import youtubePlayPng from '../../assets/images/common/youtube-play.svg';
import youtubePlayPng from '../../assets/images/common/youtu_player.png';
import { sanitizedHTML } from '../../utils/Helper';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faSearch } from '@fortawesome/free-solid-svg-icons';

const CustomFooter = (props) => {
  const { footer_config } = props;

  return (
    <>
      <Container>
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizedHTML(footer_config?.custom_footer_html || ''),
          }}
        />
        {/* <Row className="row1">
          <Col xs={12} sm={12} md={8} lg={8} xl={8} xxl={8}>
            <a href={footer_config.logo.link} target="_blank">
              <img src={footer_config.logo.url} className="logo" />
            </a>
          </Col>
          <Col xs={12} sm={12} md={2} lg={2} xl={2} xxl={2} className="link-col">
            <div className="link-title">{footer_config.followUs.title}</div>
            <br />
            <div>
              <a href={footer_config.followUs.icon[0].link} target="_blank">
                <img src={facebookPng} className="icon" />
              </a>
              <a href={footer_config.followUs.icon[1].link} target="_blank">
                <img
                  src=""
                  className="icon"
                />
              </a>
              <a href={footer_config.followUs.icon[2].link} target="_blank">
                <img src={youtubePlayPng} className="icon3" />
              </a>
            </div>
          </Col>
          <Col xs={12} sm={12} md={2} lg={2} xl={2} xxl={2} className="link-col">
            <div
              className="link-title"
              dangerouslySetInnerHTML={{ __html: sanitizedHTML(footer_config.custom_footer_html) }}
            />
          </Col>
        </Row>
        <Row className="row2">
          <Col>{footer_config.copyInfo}</Col>
        </Row> */}
      </Container>
    </>
  );
};

export default CustomFooter;
